import {
  AddAlarm,
  CorporateFare,
  Dashboard,
  Description,
  Fence,
  Home,
  LabelOutlined,
  Person,
  Router,
  DirectionsCar,
} from "@mui/icons-material";
import { CONFIG } from "../config";

/**
 * Builds the top-level sidebar navigation items. The trips entry is included
 * only when trip registry is enabled in config.
 */
export function getSidebarMenuItems() {
  return [
    { path: "/", icon: <Home />, label: "common.home" },
    {
      path: "/device",
      icon: <Router />,
      label: "common.devices",
      subItems: "devices",
    },
    ...(CONFIG.trip_registry_enabled
      ? [
          {
            path: "/trips",
            icon: <DirectionsCar />,
            label: "common.trips",
          },
        ]
      : []),
    {
      path: "/label",
      icon: <LabelOutlined />,
      label: "labels.index",
      subItems: "labels",
    },
    {
      path: "/action",
      icon: <AddAlarm />,
      label: "common.actions",
      subItems: "actions",
    },
    {
      path: "/geofence",
      icon: <Fence />,
      label: "common.geofences",
      subItems: "geofences",
    },
    {
      path: "/dashboard",
      icon: <Dashboard />,
      label: "common.dashboards",
      subItems: "dashboards",
    },
    {
      path: "/report",
      icon: <Description />,
      label: "common.reports",
      subItems: "reports",
    },
    {
      path: "/contact",
      icon: <Person />,
      label: "common.contacts",
      subItems: "contacts",
    },
    {
      path: "/organisation",
      icon: <CorporateFare />,
      label: "common.organisations",
      subItems: "organisations",
    },
  ];
}
